module.exports = __webpack_public_path__ + "static/media/cc-discover.cfbf4333.svg";